import React, {useEffect} from 'react'
import useUpdate from './useUpdate'
import { Arc } from './Arc'
import {getPercentageFromValue} from './utils.js';
import { Pointer } from './Pointer'
import { Scale } from './Scale'
import { Value } from './Value'

const stepsToSnapTo = (steps, snap) =>
    steps && snap
        ? Array.from({ length: steps + 1 }, (_, i) => (1 / steps) * i)
        : undefined

const isInternalComponent = ({ type }) =>
    type === Arc || type === Pointer || type === Scale || type === Value

export const Knob = ({
    min,
    max,
    value: initialValue,
    angleOffset = 0,
    angleRange = 360,
    size,
    onChange = () => {},
    children,
    scrollContainer,
    steps,
    snap = false,
    ariaValueText,
    ariaLabelledBy,
    className,
}) => {
     let update = useUpdate({
        min,
        scrollContainer,
        max,
        initialValue,
        angleOffset,
        percentage: getPercentageFromValue(initialValue, min, max),
        angleRange,
        size,
        steps: stepsToSnapTo(steps, snap),
        onChange,
    })

    const {
        dispatch,
        onStart,
        svg,
        container,
        onKeyDown,
        onScroll,
    } = update;

    let value = initialValue;

    let percentage = initialValue !== undefined ? (initialValue - min) / (max - min) : 0;

    useEffect(() => {
        onChange(update.value);
    }, [update.value]);

    useEffect(() => { 
        dispatch({
            scrollContainer,
            type: 'SCROLL_CONTAINER'
        });
    }, [scrollContainer]);

    return (
        <div
            ref={container}
            tabIndex="0"
            style={{ outline: 'none', width: size, height: size }}
            aria-valuemax={max}
            aria-valuemin={min}
            aria-valuenow={value}
            aria-valuetext={ariaValueText}
            aria-labelledby={ariaLabelledBy}
            onKeyDown={onKeyDown}
            onWheel={onScroll}
            className={className}
        >
          <svg onMouseDown={(e) => {
              e.preventDefault();
              onStart(e);
          }} width={size} height={size} ref={svg}>
                {React.Children.map(children, child =>
                    isInternalComponent(child)
                        ? React.cloneElement(child, {
                              percentage,
                              size,
                              value,
                              angleOffset,
                              angleRange,
                              radius: size / 2,
                              center: size / 2,
                              steps,
                              ...child.props,
                          })
                        : child
                )}
            </svg>
        </div>
    )
}
